// src/pages/admin/AdminSeedPage/AdminSeedPage.jsx
// This is a temporary admin page to seed your Firebase database with products
// Access it at: /admin/seed

import React, { useState } from 'react';
import { seedProducts } from '../../../utils/seedProducts';
import './AdminSeedPage.css';

const AdminSeedPage = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSeed = async () => {
    if (window.confirm("Êtes-vous sûr de vouloir ajouter des produits à la base de données ?")) {
      setLoading(true);
      setResult(null);
      
      try {
        const res = await seedProducts();
        setResult(res);
      } catch (error) {
        setResult({
          success: false,
          message: 'Une erreur est survenue',
          error: error.message
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="admin-seed-page">
      <div className="admin-seed-container">
        <div className="admin-seed-card">
          <h1 className="admin-seed-title">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
              <line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
            Ajouter des Produits
          </h1>
          
          <p className="admin-seed-description">
            Cette page vous permet d'ajouter des produits d'exemple à votre base de données Firebase.
            Cliquez sur le bouton ci-dessous pour commencer.
          </p>

          <div className="admin-seed-warning">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <div>
              <strong>Attention :</strong> Cette opération ajoutera 8 produits d'exemple à votre base de données.
              Assurez-vous que votre configuration Firebase est correcte.
            </div>
          </div>

          <button 
            onClick={handleSeed} 
            disabled={loading}
            className="admin-seed-button"
          >
            {loading ? (
              <>
                <div className="spinner"></div>
                Ajout en cours...
              </>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="17 8 12 3 7 8"/>
                  <line x1="12" y1="3" x2="12" y2="15"/>
                </svg>
                Ajouter les Produits
              </>
            )}
          </button>
          
          {result && (
            <div className={`admin-seed-result ${result.success ? 'success' : 'error'}`}>
              <div className="result-icon">
                {result.success ? (
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                ) : (
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                  </svg>
                )}
              </div>
              <div className="result-content">
                <h3 className="result-title">
                  {result.success ? '✓ Succès' : '✗ Erreur'}
                </h3>
                <p className="result-message">{result.message}</p>
                {result.successCount !== undefined && (
                  <div className="result-stats">
                    <div className="result-stat">
                      <span className="result-stat-label">Produits ajoutés :</span>
                      <span className="result-stat-value">{result.successCount}</span>
                    </div>
                    {result.errorCount > 0 && (
                      <div className="result-stat error">
                        <span className="result-stat-label">Erreurs :</span>
                        <span className="result-stat-value">{result.errorCount}</span>
                      </div>
                    )}
                  </div>
                )}
                {result.error && (
                  <p className="result-error-detail">{result.error}</p>
                )}
              </div>
            </div>
          )}

          <div className="admin-seed-instructions">
            <h3>Instructions :</h3>
            <ol>
              <li>Assurez-vous que votre fichier <code>firebaseconfig.js</code> est correctement configuré</li>
              <li>Vérifiez que vous avez les permissions nécessaires dans Firebase</li>
              <li>Cliquez sur le bouton "Ajouter les Produits"</li>
              <li>Une fois terminé, vous pouvez accéder aux produits sur la page <a href="/products">/products</a></li>
              <li>Cette page peut être supprimée après l'ajout initial des produits</li>
            </ol>
          </div>

          <div className="admin-seed-note">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
            <p>
              Cette page est uniquement pour l'administration. 
              Après avoir ajouté les produits, vous pouvez supprimer cette route de votre application.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSeedPage;